import { BaseCategory } from "./BaseCategory";
import { ElementTextBlockPositionType, HorizontalAlignType, PositionType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class BiographyCategory extends BaseCategory {
    get name() {
        return "Biography";
    }

    get type() {
        return SlideCategories.BIOGRAPHY;
    }

    get icon() {
        return null;
    }

    get description() {
        return "Use for presenting biographical information about a person, including their background, accomplishments, and relevant details with a photo.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Create a biography slide for the person mentioned in the user's prompt.
        Provide the person's exact name and a biographical description.
        Provide a required photoSearch that begins with the person's exact name and describes an appropriate photo of that person.`;
    }

    getPromptSchema() {
        return {
            personName: "the exact name of the person",
            biographyText: ["richtext biography or description of the person (do not include the person's name here)"],
            photoSearch: "required search term beginning with the exact personName (e.g., 'Ada Lovelace portrait', 'Grace Hopper professional headshot')",
        };
    }

    getImagePrompt() {
        return super.getImagePrompt();
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildBiographySlide(model, options),
        ];

        return models;
    }

    buildBiographySlide(model, options = {}) {
        let builder = new SlideModelBuilder("headline2", model);

        if (model.biographyText) {
            for (let block of model.biographyText) {
                if (block.textStyle === TextStyleType.HEADING) {
                    block.textStyle = TextStyleType.TITLE;
                }
                if (block.textStyle === TextStyleType.BULLET_LIST) {
                    block.indent = (block.indent ?? 0) + 1;
                }
            }
        }

        let primary = {
            fullBleed: true,
            showGutter: true,
            headlinePosition: PositionType.RIGHT,
            textPosition: PositionType.LEFT,
            textAlign: HorizontalAlignType.LEFT,
            text: {
                blocks: [
                    builder.createBlock(model.personName, TextStyleType.HEADING),
                    ...model.biographyText || []
                ]
            },
        };

        // Prefer the person-specific search over a generic slide image prompt.
        const hasPersonSearch = !!(model.personName || model.photoSearch);
        const imagePrompt = hasPersonSearch
            ? this.enhancePhotoSearch(model.photoSearch, model.personName)
            : model.slideImage?.prompt;
        primary.items = [{
            componentType: "TextAndImage",
            childElement: builder.createImage(imagePrompt, {}, !hasPersonSearch && !!model.slideImage?.prompt)
        }];

        builder.createPrimary(primary);

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.INLINE);
        }

        return builder.model;
    }

    enhancePhotoSearch(searchTerm, personName) {
        return this.ensureSearchIncludesName(searchTerm, personName, "portrait");
    }
}
